import {Component} from 'panel';

import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {setOptState} from 'media/js/gdpr/opt';

import {template} from './template';
import css from './index.styl?inline';

export interface CookieCenterState {
  optCookies: boolean;
}

export class CookieCenter extends Component<CookieCenterState> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
      defaultState: {
        optCookies: null,
      },
      helpers: {
        handleSwitchChange: (ev: CustomEvent) => this.update({optCookies: ev.detail.on}),
        handleSave: async () => {
          const {success} = await setOptState(this.state.optCookies ? `in` : `out`, `storage`);
          if (success) {
            addToast({type: ToastType.SUCCESS, message: `Cookie preferences updated`});
          } else {
            addToast({type: ToastType.ERROR, message: `Something went wrong updating preferences`});
          }
        },
      },
    };
  }

  async connectedCallback() {
    super.connectedCallback();
    await window.gdprData.waitUntilReady();
    this.update({optCookies: window.gdprData.allowStorage});
  }
}

customElements.define(`mp-cookie-center`, CookieCenter);
export const CookieCenterEl = defineAndMakeJsxFactory(`mp-cookie-center`, CookieCenter);
